// removed by extract-text-webpack-plugin
module.exports = {"Form":"src-components-Forms-__Form-module___Form","Description":"src-components-Forms-__Form-module___Description","Forgot":"src-components-Forms-__Form-module___Forgot","Button":"src-components-Forms-__Form-module___Button","Input":"src-components-Forms-__Form-module___Input"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Forms/Form.module.css
// module id = 447
// module chunks = 1